module.exports = __webpack_public_path__ + "img/69.3f066941.jpg";